import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Button,
  InputAdornment,
  Stack,
  SxProps,
  Typography,
  useTheme,
} from "@mui/material";
import { FormEvent, useState } from "react";
import { LoginCredentials } from "../../data/login-page";
import { GeneralButtonLabel, LoginPageText } from "../../data/texts";
import { Images } from "../../models/assets-files";
import { InputType, VoidFunction } from "../../models/common.models";
import { Credentials } from "../../pages/LoginPage";
import { ImageService } from "../../services/image.service";
import StyledLoginField from "../../styled-cmps/login-field";
import Image from "../common/Image";
import useScreen from "../common/UseScreen";

interface LoginFormProps {
  containerSx?: SxProps;
  handleResetPassword?: VoidFunction;
  handleSubmit: (
    ev: FormEvent<HTMLFormElement>,
    credentials: Credentials
  ) => void;
}

const LoginForm = ({
  handleSubmit,
  containerSx,
  handleResetPassword,
}: LoginFormProps) => {
  const theme = useTheme();
  const { isDesktop, isMobile } = useScreen();
  const [shouldHidePassword, setShouldHidePassword] = useState(true);
  const [credentials, setCredentials] = useState<Credentials>({
    email: "",
    password: "",
  });

  const handleInput = (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setCredentials({ ...credentials, [ev.target.name]: ev.target.value });
  };

  return (
    <Box sx={{ ...containerSx }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: isDesktop ? "65%" : isMobile ? "90%" : "70%",
          marginInline: "auto",
        }}
      >
        <Image
          sx={{ width: "259px", alignSelf: "center", marginBottom: "30px" }}
          src={ImageService.getLocalImgPath(
            Images.Folders.GENERAL,
            Images.General.LOGO_DARKER
          )}
        />
        <Stack gap="5px" sx={{ marginBottom: "20px" }}>
          <Typography
            sx={{ fontSize: isDesktop ? "25px" : "18px", fontWeight: "600" }}
          >
            {LoginPageText.WELCOME}
          </Typography>
          <Typography sx={{ fontSize: "16px", fontWeight: "300" }}>
            {LoginPageText.DIGITAL_DASHBOARD}
          </Typography>
        </Stack>
        <Box
          component={"form"}
          autoComplete="on"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            justifyContent: "center",
            alignSelf: "stretch",
          }}
          onSubmit={(ev) => handleSubmit(ev, credentials)}
        >
          <StyledLoginField
            autoFocus
            id={LoginCredentials.EMAIL}
            slotProps={{
              input: { autoComplete: "on" },
            }}
            key={LoginCredentials.EMAIL}
            required
            onChange={handleInput}
            label={LoginCredentials.EMAIL.capitalize()}
            name={LoginCredentials.EMAIL}
            type={InputType.TEXT}
          />
          <StyledLoginField
            id={LoginCredentials.PASSWORD}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment
                    sx={{ cursor: "pointer" }}
                    position="end"
                    onClick={() => setShouldHidePassword(!shouldHidePassword)}
                  >
                    {shouldHidePassword ? <Visibility /> : <VisibilityOff />}
                  </InputAdornment>
                ),
              },
            }}
            key={LoginCredentials.PASSWORD}
            required
            onChange={handleInput}
            label={LoginCredentials.PASSWORD.capitalize()}
            name={LoginCredentials.PASSWORD}
            type={shouldHidePassword ? InputType.PASSWORD : InputType.TEXT}
          />
          <Button
            type="submit"
            sx={{
              background: theme.palette.text.primary,
              borderRadius: "10px",
              marginBottom: isDesktop ? "10px" : "20px",
            }}
            variant="contained"
          >
            {GeneralButtonLabel.SIGNIN.toUpperCase()}
          </Button>
        </Box>
        <Stack
          alignItems={!isMobile ? "center" : "flex-start"}
          direction={!isMobile ? "row" : "column"}
          justifyContent={"space-between"}
          sx={{ marginBottom: isDesktop ? "10px" : "15px" }}
        >
          {/* <Typography
            sx={{
              textAlign: "center",
              fontWeight: "200",
              background: "transparent",
            }}
          >
            {LoginPageText.FORGOT_PASSWORD}
          </Typography> */}
          <Button
            onClick={handleResetPassword}
            sx={{
              padding: "0",
              color: theme.palette.text.primary,
              height: "50px",
              background: "transparent",
            }}
          >
            {LoginPageText.RESET_PASSWORD}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default LoginForm;
